import useSWR from "swr";
import axios from "axios";

function useProject({ projectId }) {
  return useSWR([`${process.env.REACT_APP_API_URL}/projects/${projectId}`], async ([url]) => {
    const { data: project } = await axios.get(url);

    return { project };
  });
}

export default useProject;
